import { useQueries } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import { NormalizedIndexResponseType } from '@/types/apiTypes';

const useIndexSeriesList = (ids: string[]) => {
  return useQueries({
    queries: ids.map((id) => ({
      queryKey: ['indexSeries', id],
      queryFn: async (): Promise<NormalizedIndexResponseType | null> => {
        const URL = `${import.meta.env.VITE_API_INDEX_NORMALIZED_URL}?id=${id}`;
        const { data } = await axiosClient.get<NormalizedIndexResponseType>(URL);

        return data;
      },
      staleTime: Infinity,
    })),
  });
};

export default useIndexSeriesList;
